<template>
    <v-dialog v-model="show" fullscreen hide-overlay transition="fade-transition">
        <v-card class="fill-height">
            <v-container class="d-flex flex-column align-center justify-space-between fill-height py-12">
                <div class="py-2" :class="{'py-8': platform === 'ios'}">
                    <logo />
                </div>
                <div class="w-100 px-3">
                    <v-btn depressed color="secondary" large block :to="{name: 'login'}">
                        <v-icon class="me-2">mdi-login-variant</v-icon>
                        <span>Login</span>
                    </v-btn>
                    <v-btn block depressed outlined color="primary" large class="mt-4" :to="{name: 'register'}">
                        <v-icon class="me-2">mdi-account-plus</v-icon>
                        <span>Register</span>
                    </v-btn>
                    <v-btn v-if="platform === 'ios'" depressed outlined text large block class="mt-4" :to="{name: 'courses'}">
                        <v-icon class="me-2">mdi-play-box-multiple-outline</v-icon>
                        <span>Courses</span>
                    </v-btn>
                </div>
                <div>
                    <v-btn text style="opacity: 0.7" :to="{name: 'help'}">
                        Need help?
                    </v-btn>
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: "app-welcome",
    props: {
        value: {}
    },
    data(){
        return {
            show: false,
        }
    },
    components: {
        
    },
    computed: {
        ...GlobalComputed,
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    methods: {
        ...GlobalMethods,
    },
    created(){
        if (this.show !== this.value){
            this.show = this.value;
        }
    }
};
</script>
